export type DataLayer = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: DataLayer[];
  }
}

export const initializeGtm = (gtmId: string, dataLayer?: DataLayer): void => {
  if (!gtmId) return;

  window.dataLayer = window.dataLayer ?? [];

  // Check if GTM is already loaded within the DOM
  const gtmLoaded = document.querySelector(
    `script[src*="googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}"]`,
  );

  // If the GTM script is already loaded within the DOM return and do nothing
  if (gtmLoaded) {
    console.log("already loaded");
    return;
  }

  // Push initial data before GTM loads
  if (dataLayer) {
    window.dataLayer.push(dataLayer);
  }

  // Load GTM
  window.dataLayer.push({
    "gtm.start": Date.now(),
    event: "gtm.js",
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
    gtmId,
  )}`;

  document.head.appendChild(script);
};

export const gtmPush = (data: DataLayer) => {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(data);
};
